import React from 'react';
import PspUsers from './PspUsers';
import styles from './Psp.module.scss';
import { Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import SetUser from './SetUser';


export default class Psp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModifyingUser: false,
    };

    this.onOpenUserModal = this.onOpenUserModal.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.onAddUsers = this.onAddUsers.bind(this);
  }


  onOpenUserModal() {
    this.setState({ isModifyingUser: true });
  }

  onCloseModal = () => {
    this.setState({
      isModifyingUser: false,
    });
  };

  onAddUsers() {
    this.onOpenUserModal();
  }

  render() {
    const linkedUsers=this.props.linkedUsers||[];

    return (
      <div className={styles.root}>
        <div
          style={{
            marginTop: '10px',
          }}
        >
          <div className={styles.title}>
            Manage Users
          </div>
          <div style={{display: "flex",justifyContent: "end"}}>
             <Button
                variant="contained"
                style={{backgroundColor:'#FFE916', fontSize: '13px', color:"#434F69", boxShadow:"none", fontFamily: 'gilroy-regular'}}
                startIcon={<AddIcon />}
                onClick={this.onAddUsers}
            >
                Add New
            </Button>
          </div>
          {
            <PspUsers
              users={linkedUsers}
              deleteProviderLinkedUserFunc={this.props.deleteProviderLinkedUserFunc}
              provider={this.props.provider}
            />
          }
          <SetUser
          users={linkedUsers}
          isModifyingUser={this.state.isModifyingUser}
          onCloseFunc={this.onCloseModal}
          provider={this.props.provider}
          getProviderLinkedUsersFunc={this.props.getProviderLinkedUsersFunc}
          />
        </div>
      </div>
    );
  }
}
